import { Slide, useScrollTrigger } from "@mui/material";
import { IHideOnScrollProps } from "./HideOnScroll.types";

const HideOnScroll = ({ children, window }: IHideOnScrollProps) => {
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
};

export default HideOnScroll;
